class BookingDate{
  constructor(constructorObj){
    for(var key in constructorObj){
      if(constructorObj[key]){
        this[key] = constructorObj[key]
      }
    }

    if(this.wasteStreams && typeof this.wasteStreams == "string"){ // This assumes waste streams are a CSV of hypen-delimited pairs

      var wasteStreamArr = this.wasteStreams.split(',')
      
      for (let i = 0; i < wasteStreamArr.length; i++) {
        wasteStream = wasteStreamArr[i].split('-')
        wasteStreamArr[i] = {
          serviceApiValue : wasteStream[0],
          wasteStreamApiValue : wasteStream[1],
        }  
      } 

      this.wasteStreams = wasteStreamArr
    }
  }

  hasService(serviceApiValue){
    serviceApiValue = serviceApiValue.toLowerCase()
    if(this.wasteStreams && Array.isArray(this.wasteStreams) && this.wasteStreams.length > 0){
      service = this.wasteStreams.find(wasteStream =>{
        return serviceApiValue == wasteStream.serviceApiValue.toLowerCase()
      })
      
      return service != null
    }
    return false
  }

  hasWasteStreamApiValue(wasteStreamApiValue){
    if (!wasteStreamApiValue) return false;
    wasteStreamApiValue = wasteStreamApiValue.toLowerCase()
    if(this.wasteStreams && Array.isArray(this.wasteStreams) && this.wasteStreams.length > 0){
      wasteStream = this.wasteStreams.find(wasteStream =>{
        return wasteStreamApiValue == wasteStream.wasteStreamApiValue.toLowerCase()
      })
      
      return wasteStream != null
    }
    return false
  }
}

module.exports = BookingDate